import { gql, useQuery } from '@apollo/client'

const GET_ALL_POSITIONS_QUERY = gql`
  query {
    positions(orderBy: borrowedAmountValue, orderDirection: desc) {
      id
      owner
      synth
      collateralAmountSign
      collateralAmountValue
      borrowedAmountSign
      borrowedAmountValue
    }
  }
`

const GET_ACCOUNT_POSITIONS_QUERY = gql`
  query GetAccountPositionsQuery($account: Bytes!) {
    positions(where: { owner_contains: $account }) {
      id
      owner
      synth
      collateralAmountSign
      collateralAmountValue
      borrowedAmountSign
      borrowedAmountValue
    }
  }
`

/**
 * Returns the positions from TheGraph
 * @param account (optional) If you want to filter the positions by account, pass the account address
 * @param pollInterval (optional) Interval for poll
 */
export function usePositions(account?: string, pollInterval?: number) {
  const query = account ? GET_ACCOUNT_POSITIONS_QUERY : GET_ALL_POSITIONS_QUERY
  const { data, loading, error } = useQuery(query, {
    pollInterval: pollInterval,
    variables: {
      account,
    },
  })

  if (error) {
    console.error(`Error getting positions: ${error}`)
  }

  return {
    loading,
    error,
    positions: data?.positions,
  }
}
